import React from 'react';
import { RouteObject, createBrowserRouter, Navigate } from 'react-router-dom';
import { LoginScreen } from '../presentation/login';
import { DashboardScreen } from 'src/presentation/dashboard';
import { ReportsScreen } from 'src/presentation/reports';
import { AnalysisScreen } from 'src/presentation/analysis';
import { MainLayout } from 'src/presentation/main';
import { AutomationsScreen } from 'src/presentation/insights/automations/indext';
import { AnalyticsScreen } from 'src/presentation/insights/analytics';
import { ExpenseTrackerScreen } from 'src/presentation/expense-tracker';
import { AiAssistantScreen } from 'src/presentation/insights/ai-assistant';
import { EngagementScreen } from 'src/presentation/engagement';
import { ReviewsScreen } from 'src/presentation/engagement/reviews';
import { CheckinsScreen } from 'src/presentation/checkins';
import { TermsOfUseScreen } from 'src/presentation/legal/terms-of-use';
import { PrivacyPolicyScreen } from 'src/presentation/legal/privacy-policy';
import { SettingsScreen } from 'src/presentation/settings';
import { BillingScreen } from 'src/presentation/billing';
import { CampaignsScreen } from 'src/presentation/campaigns';
import { ReviewLandingScreen } from 'src/presentation/review-landing';
import { ConnectAppsScreen } from 'src/presentation/connect';

const baseRoutesConfig: RouteObject[] = [
  {
    path: '/',
    element: <Navigate to="/home" />,
  },
  {
    path: '/keywords',
    element: <Navigate to="/home/keywords" />,
  },
  {
    path: '/auth/login',
    element: <Navigate to="/home" />,
  },
  {
    path: '/home',
    element: <MainLayout />,
    children: [
      { index: true, element: <Navigate to="/home/reviews" /> },
      { path: 'keywords', element: <EngagementScreen /> },
      { path: 'reviews', element: <ReviewsScreen /> },
      { path: 'checkins', element: <CheckinsScreen /> },
      { path: 'reports', element: <ReportsScreen /> },
      { path: 'campaigns', element: <CampaignsScreen /> },
      { path: 'dashboard', element: <DashboardScreen /> },
      { path: 'assistant', element: <AiAssistantScreen /> },
      { path: 'analytics', element: <AnalyticsScreen /> },
      { path: 'expenses', element: <ExpenseTrackerScreen /> },
      { path: 'automations', element: <AutomationsScreen /> },
      { path: 'connect', element: <ConnectAppsScreen /> },
      { path: 'settings', element: <SettingsScreen /> },
      { path: 'billing', element: <BillingScreen /> },
    ],
  },
  {
    path: '/analysis',
    element: <AnalysisScreen />,
  },
  {
    path: '/review/:locationId',
    element: <ReviewLandingScreen />,
  },
  {
    path: '/terms-of-use',
    element: <TermsOfUseScreen />,
  },
  {
    path: '/privacy-policy',
    element: <PrivacyPolicyScreen />,
  },
];

const authRoutesConfig: RouteObject[] = [
  {
    path: '/',
    element: <Navigate to="/auth/login" />,
  },
  {
    path: '/keywords',
    element: <Navigate to="/auth/login" />,
  },
  {
    path: '/*',
    element: <Navigate to="/" />,
  },
  {
    path: 'auth',
    children: [
      {
        path: 'login',
        element: <LoginScreen />,
      },
    ],
  },
  {
    path: '/analysis',
    element: <AnalysisScreen />,
  },
  {
    path: '/review/:locationId',
    element: <ReviewLandingScreen />,
  },
  {
    path: '/terms-of-use',
    element: <TermsOfUseScreen />,
  },
  {
    path: '/privacy-policy',
    element: <PrivacyPolicyScreen />,
  },
];

const createRoutes = (isUserLoggedIn: boolean) =>
  createBrowserRouter(isUserLoggedIn ? baseRoutesConfig : authRoutesConfig);

const defaultRoutes = createBrowserRouter(authRoutesConfig);

export { createRoutes, defaultRoutes };
